<template>
  <div class="content-container">
    <span v-if="!isAuthenticated">
      <h2>Bitte anmelden, um die Applikation zu verwenden.</h2>
    </span>

    <template v-else>
      <Card class="menu-card">
        <template #title>
          <div class="card-title">Funktion wählen</div>
        </template>
        <template #content>
          <Button @click="router.push({ name: RouteNames.ERLAUBNISKARTEN })">
            <i class="pi pi-credit-card"></i>
            Erlaubniskarten exportieren
          </Button>
          <Button @click="router.push({ name: RouteNames.FAHRBEWILLIGUNGEN })">
            <i class="pi pi-credit-card"></i>
            Fahrbewilligung erzeugen
          </Button>
        </template>
      </Card>
    </template>
  </div>
</template>

<script setup lang="ts">
  import Button from "primevue/button";
  import { useIsAuthenticated } from "@/composition-api/useIsAuthenticated";
  import { useRouter } from "vue-router";
  import { RouteNames } from "@/router/RouteNames";
  import Card from "primevue/card";

  const router = useRouter();
  const isAuthenticated = useIsAuthenticated();
</script>

<style scoped lang="scss">
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem 2rem;

    button {
      font-size: 1.2rem;
      margin: 0.5rem;
    }

    .menu-card {
      text-align: center;
      margin-top: 2rem;
    }

    .card-title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 1em;
      font-weight: bold;
    }
  }
</style>
